import React, {use, useEffect, useState} from 'react';
import { connect } from 'react-redux';
import LogoSvg from '../../..//svg/Logo.js';
import { useCookies } from 'react-cookie';
import {cookies_string} from '../../../config.js';
import { Login } from '../../../actions/actions.js';
import { useNavigate, useLocation } from 'react-router-dom';
import { fetchUserDataById } from '../../../services2/users.service.js';
import { teacherFetchSchoolInfo } from '../../../services2/schools.service.js';
import { useSetting } from '../../../util/useSetting.js';
function Component(props) {
    const {fontSize,updateFontSize} = useSetting();
    const navigate = useNavigate();
    const location = useLocation();
    const [ __, _, removeCookie] = useCookies([`${cookies_string}_cred`,`${cookies_string}_token`]);
    const [isShowMenu,setisShowMenu]=useState(false)
	const handleLogout=()=>{
		props.dispatch(Login(false))
        removeCookie(`${cookies_string}_token`,'/')
        removeCookie(`${cookies_string}_cred`,'/')   
	}
    const toggleMenu=()=>{setisShowMenu(!isShowMenu)}
    const handleRoute=(route)=>()=>{
        navigate(`/platform2/${route}`);
    }

    const [user,setuser]=useState(null)
    const [school,setSchool]=useState(null)

    async function fetchData(){
        let result = await fetchUserDataById(props.token.token)
        if( result.result){
            setuser(result.result)
            let schoolData = await teacherFetchSchoolInfo(props.token.token)
            if(schoolData.result){
                setSchool(schoolData.result)
            }
            
        }
    }
    useEffect(()=>{
        if(props.token.token)
            fetchData()
    },[props.token.token])

    const [isSettingMenuVisible,setisSettingMenuVisible]=useState(false)

    const isMobile=window.innerWidth<1024;
    if(props.token.usertype==='student'&&location.pathname.split('/')[3]!==undefined&&location.pathname.split('/')[2]==='missions'){
        return(<div/>)
    }
    if(props.token.usertype==='p-student'&&location.pathname.split('/')[3]!==undefined&&location.pathname.split('/')[2]==='missions'){
        return(<div/>)
    }
    if (location.pathname.split('/')[2] !== undefined && location.pathname.split('/')[2] === 'task-4') {
        return (<div />)
    }
    if(location.pathname.split('/')[2]==='missions'&&location.pathname.split('/')[3])
        return null;
    if(location.pathname.split('/')[2]==='research-practices'&&location.pathname.split('/')[3]&&location.pathname.split('/')[3]!=='preview')
        return null;
    return(
        <div className='bg-[white] w-full flex flex-row justify-between items-center px-[16px] py-[24px] text-[1rem]' style={{overflowX:'auto', fontSize: fontSize}}>
            <div>
                {school?.name?`${school?.name}`:''}
            </div>
  
            <div className='flex flex-row items-center' style={{gap:isMobile?'8px':'24px'}}>
                <div>{user?.name?`姓名: ${user?.name}`:props.token?.username}</div>
                <div>{user?.class?`班級: ${user?.class}`:''}</div>

                <button className='px-[18px] py-[4px] rounded-full flex flex-row items-center text-[white] gap-[8px] noto-san-hk font-[600]' style={{background:'linear-gradient(to right, #34778C, #63BBD1)'}} onClick={()=>setisSettingMenuVisible(!isSettingMenuVisible)}>
                    <img src='/secondary/setting.png' alt='設定' />
                    設定
                </button>
            </div>
            {isSettingMenuVisible && (
                <div className='absolute inset-0 flex justify-center items-center p-[16px] bg-[black] z-[999]'>
                    <div className='flex flex-col min-w-[600px] max-w-[90vw] rounded-[16px]'>
                        <div className='w-full py-[8px] text-center font-[900] text-[#003A57] bg-[#D9F4F4]' style={{ borderTopLeftRadius: '16px', borderTopRightRadius: '16px' }}>
                            設定
                        </div>
                        <div className='w-full flex flex-col justify-start items-center p-[16px] bg-[white]' style={{backgroundImage: 'url(/secondary/bg5.png)', backgroundSize: 'cover', backgroundPosition: 'center',borderBottomLeftRadius: '16px', borderBottomRightRadius: '16px'}}>
                            <div className='font-slider w-full flex flex-row gap-[8px] items-center justify-center p-[24px] py-[48px]'>
                                <div className='font-bold mr-[24px]'>字體大小</div>
                                <button className='bg-[#108B96] rounded-[8px] text-white w-[37px] h-[37px] flex items-center justify-center font-[900] text-[32px] pb-[8px]'
                                    onClick={()=>{
                                        if(fontSize<=14)return
                                        updateFontSize(fontSize-2)
                                    }}
                                >-</button>
                                <input className='flex-1 max-w-[200px]' type='range' min={14} max={22} step={2} value={fontSize} onChange={(e)=>updateFontSize(Number(e.target.value))} />
                                <button className='bg-[#108B96] rounded-[8px] text-white w-[37px] h-[37px] flex items-center justify-center font-[900] text-[36px] pb-[2px]' onClick={
                                    ()=>{
                                        if(fontSize>=22)return
                                        updateFontSize(fontSize+2)
                                    }
                                }>+</button>
                            </div>
                             <div className='flex flex-row px-[32px] items-center flex-wrap justify-center gap-[16px] mt-[48px]'>
                                <button className='bg-white rounded-full py-[8px] px-[20px] flex flex-row items-center gap-[16px] text-[#34778C] font-[700]' style={{boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)'}}>
                                    <img src='/secondary/b1.png' alt='' className='h-[32px] w-[32px]'/>
                                    常見探究
                                </button>
                                <button className='bg-white rounded-full py-[8px] px-[20px] flex flex-row items-center gap-[16px] text-[#34778C] font-[700]' style={{boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)'}}>
                                    <img src='/secondary/b2.png' alt='' className='h-[32px] w-[32px]'/>
                                    使用條款
                                </button>
                                <button className='bg-white rounded-full py-[8px] px-[20px] flex flex-row items-center gap-[16px] text-[#34778C] font-[700]' style={{boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)'}}>
                                    <img src='/secondary/b3.png' alt='' className='h-[32px] w-[32px]'/>
                                    私隱條款
                                </button>
                                <button className='bg-white rounded-full py-[8px] px-[20px] flex flex-row items-center gap-[16px] text-[#34778C] font-[700]' style={{boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)'}}>
                                    <img src='/secondary/b4.png' alt='' className='h-[32px] w-[32px]'/>
                                    聯絡我們
                                </button>
                            </div>
                            <button className='mt-[48px] px-[48px] py-[6px] text-white rounded-full font-[700] noto-san-hk' style={{background:'linear-gradient(to right, #34778C, #63BBD1)'}} onClick={()=>{
                                setisSettingMenuVisible(false)
                            }}>
                                離開
                            </button>
                        </div>
                       
                    </div>
                </div>
            )}
        </div>
    )
}
export default connect((store)=>{
    return{
      token:store.tokenReducer,
    }
  })(Component)